var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductHeader',{attrs:{"title":"Nuevo Producto"}}),_c('hr'),_c('ProductForm',{attrs:{"product":_vm.product},on:{"onCreate":_vm.onCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }